import Echo from '../../services/echo';

const state = {
  name: '',
  channel: null,
  userChannelName: '',
  userChannel: null,
  presence: []
};

const getters = {};

const actions = {
  join({commit, dispatch, state, rootState}, code) {
    commit('setName', `Game.${code}`);
    commit('setChannel', Echo.join(state.name));

    commit('setUserChannelName', `User.${rootState.user.id}`);
    commit('setUserChannel', Echo.private(state.userChannelName));

    dispatch('handlePresenceEvents');
    dispatch('handleMemberEvents');
    dispatch('handleVoteEvents');
    dispatch('handleGameStateEvents');
  },
  leave({commit, state}) {
    Echo.leave(state.name);
    commit('setChannel', null);

    Echo.leave(state.userChannelName);
    commit('setUserChannel', null);
  },

  whisperUser({commit, state}, payload) {
    if (state.userChannel !== null) {
      state.userChannel.whisper(payload.event, payload.data);
    }
  },

  handlePresenceEvents({commit, dispatch, state}) {
    state.channel
      .here(clients => {
        commit('setPresence', clients);
        dispatch('game/update', null, {root: true});
      })
      .joining(client => commit('joinPresence', client))
      .leaving(client => commit('leavePresence', client));
  },

  handleMemberEvents({state, dispatch, rootState}) {
    state.channel
      .listen('UserJoinedGame', e => dispatch('game/addMember', e.user, {root: true}))
      .listen('UserLeftGame', e => dispatch('game/removeMember', e.user, {root: true}))
      .listen('UserKickedFromGame', e => {
        console.log('UserKickedFromGame event', e);
        dispatch('game/removeMember', e.user, {root: true});
        if (rootState.user.id === e.user.id) {
          alert('You were kicked from the game');
          window.location.href = '/';
        }
      })
      .listen('HostLeftGame', e => {
        if (e.user.id !== rootState.user.id) {
          confirm("Host has left the game.");
        }
        window.location.href = '/';
      })
     ;
  },

  handleVoteEvents({state, dispatch}) {
    state.userChannel
      .listenForWhisper('UserCastedVote', (e) => {
        dispatch('game/voted', {user: e.user, vote: e.vote}, {root: true})
      });

    state.channel
      .listen('UserCastedVote', e => dispatch('game/voted', {user: {id: e.id}, vote: true}, {root: true}))
      .listen('UserWithdrewVote', e => dispatch('game/unvoted', {id: e.id}, {root: true}))
  },

  handleGameStateEvents({state, dispatch}) {
    state.channel
      .listen('GameLocked', e => dispatch('game/lock', e.votes, {root: true}))
      .listen('GameUnlocked', e => dispatch('game/unlock', null, {root: true}));
  }
};

const mutations = {
  setUserChannelName(state, name) {
    state.userChannelName = name;
  },
  setUserChannel(state, channel) {
    state.userChannel = channel;
  },
  setName(state, name) {
    state.name = name;
  },
  setChannel(state, channel) {
    state.channel = channel;
  },
  setPresence(state, clients) {
    console.log('Here', clients);
    state.presence = clients;
  },
  joinPresence(state, client) {
    console.log('Joining', client);
    state.presence.push(client);
  },
  leavePresence(state, client) {
    console.log('Leaving', client);
    state.presence = state.presence.filter(item => item.id !== client.id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
